import { z } from 'zod';
import { api } from './api';
import {
  extraordinaryExpenseDetailSchema,
  extraordinaryExpenseReconciliationSchema,
  type ExtraordinaryExpenseDetail,
  type ExtraordinaryExpenseReconciliation,
} from '@/types/schemas';

export interface ExtraordinaryExpenseInput {
  business_unit_id: string;
  financial_period_id: string;
  expense_date: string;
  amount: string;
  expense_item: string;
  target: string;
  counterparty?: string | null;
  comment?: string | null;
}

export type ExtraordinaryExpenseUpdateInput = Partial<
  Omit<ExtraordinaryExpenseInput, 'business_unit_id' | 'financial_period_id'>
>;

export const extraordinaryExpensesService = {
  reconciliation: (
    unitId: string,
    periodId: string,
    signal?: AbortSignal,
  ): Promise<ExtraordinaryExpenseReconciliation> =>
    api.get(
      `/business-units/${unitId}/extraordinary-expenses?period_id=${periodId}`,
      extraordinaryExpenseReconciliationSchema,
      signal,
    ),

  create: (unitId: string, input: ExtraordinaryExpenseInput): Promise<ExtraordinaryExpenseDetail> =>
    api.post(`/business-units/${unitId}/extraordinary-expenses`, extraordinaryExpenseDetailSchema, input),

  update: (id: string, input: ExtraordinaryExpenseUpdateInput): Promise<ExtraordinaryExpenseDetail> =>
    api.patch(`/extraordinary-expenses/${id}`, extraordinaryExpenseDetailSchema, input),

  remove: (id: string): Promise<void> => api.delete(`/extraordinary-expenses/${id}`, z.void()),
};
